import React, { memo } from 'react';
import Avatar, { Skeleton } from '@atlaskit/avatar';
import { MediaClientProvider } from '@atlaskit/media-client-react';
import { MediaImage } from '@atlaskit/media-image';
const IMAGE_SIZE = {
  width: 24,
  height: 24
};

// We want to reuse mediaClientConfigs across all CmdbIcons to avoid extra http requests
// MediaImage internally checks for object equality to prevent image refetch.
// That's why we need to check for the individual parameters equality at this level
// and prevent the property mediaClientConfig to change
const mediaClientConfigs = new Map();
const getMediaClientConfig = ({
  mediaJwtToken,
  clientId,
  mediaBaseUrl
}) => {
  const key = `${mediaJwtToken}:${clientId}:${mediaBaseUrl}`;
  const existingMediaClientConfig = mediaClientConfigs.get(key);
  if (existingMediaClientConfig) {
    return existingMediaClientConfig;
  }
  const mediaClientConfig = {
    authProvider: () => Promise.resolve({
      clientId,
      token: mediaJwtToken,
      baseUrl: mediaBaseUrl
    }),
    useSha256ForUploads: true
  };
  mediaClientConfigs.set(key, mediaClientConfig);
  return mediaClientConfig;
};
const hasAuth = ({
  mediaBaseUrl,
  mediaJwtToken,
  fileId,
  clientId
}) => Boolean(mediaBaseUrl) && Boolean(mediaJwtToken) && Boolean(clientId) && Boolean(fileId);
const DefaultIcon = () => /*#__PURE__*/React.createElement(Avatar, {
  appearance: "square",
  size: "small"
});
const CmdbIconInternal = props => {
  if (!hasAuth(props)) {
    return /*#__PURE__*/React.createElement(DefaultIcon, null);
  }
  const fileIdentifier = {
    id: props.fileId,
    mediaItemType: 'file'
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MediaClientProvider, {
    clientConfig: getMediaClientConfig(props)
  }, /*#__PURE__*/React.createElement(MediaImage, {
    identifier: fileIdentifier,
    mediaClientConfig: getMediaClientConfig(props),
    apiConfig: IMAGE_SIZE
  }, ({
    loading,
    error,
    data
  }) => {
    if (loading) {
      return /*#__PURE__*/React.createElement(Skeleton, {
        appearance: "square",
        size: "small"
      });
    }
    if (error) {
      return /*#__PURE__*/React.createElement(DefaultIcon, null);
    }
    if (!data) {
      return /*#__PURE__*/React.createElement(DefaultIcon, null);
    }
    return /*#__PURE__*/React.createElement(Avatar, {
      src: data.src,
      appearance: "square",
      size: "small"
    });
  })));
};
export const CmdbIcon = /*#__PURE__*/memo(CmdbIconInternal);